const isStaging = window.location.hostname == 'q-www.ninox.com';
const isProduction =
    !isStaging && (window.location.hostname == 'www.ninox.com' || window.location.hostname == 'ninox.com');
const envType = isProduction ? 'prod' : isStaging ? 'qs' : 'dev';

const HSformGuids = {
    trialSignupForms: isProduction
        ? { en: '15a22ca1-75b9-4e09-9a2d-3d81b370b91c', de: 'f6cfd6be-fa65-4908-bd23-07b283f7a6f5' }
        : { en: '65db7220-2518-49aa-b6d7-12691c2d4f40', de: '549ef805-489d-4c1c-b352-39f037cc0836' }
};

const HSaccountId = isProduction ? '6876646' : '23653417';

const HSEndpoints = {
    forms: `https://api.hsforms.com/submissions/v3/integration/submit/${HSaccountId}`
};

const umsHosts = {
    prod: 'https://ums.ninox.com',
    qs: 'https://q-ums.ninox.com',
    dev: 'http://localhost:7001'
};

const appHosts = {
    prod: 'https://app.ninox.com',
    qs: 'https://qs-app.ninox.com',
    dev: 'http://localhost:8080'
};

const umsHost = umsHosts[envType];
const appHost = appHosts[envType];
const sessionInfoEndpoint = `${umsHost}/api/v3/sessions/info`;
const signupEndpoint = `${umsHost}/api/v3/credentials/signup`;
const userDetailsEndpoint = `${umsHost}/api/v3/credentials/user-details`;
const loginEndpoint = `${umsHost}/api/v3/credentials/signin`;
const logoutEndpoint = `${umsHost}/api/v3/credentials/signout`;
const googleLoginEndpoint = `${umsHost}/api/v3/credentials/google-login`;
const resetPasswordEndpoint = `${umsHost}/api/v3/credentials/requestResetPassword`;

const jsonHeader = {
    'Content-Type': 'application/json'
};

export {
    appHost,
    googleLoginEndpoint,
    HSEndpoints,
    HSformGuids,
    isProduction,
    isStaging,
    jsonHeader,
    loginEndpoint,
    logoutEndpoint,
    resetPasswordEndpoint,
    sessionInfoEndpoint,
    signupEndpoint,
    umsHost,
    userDetailsEndpoint
};
